import { render, staticRenderFns } from "./coach-rank.vue?vue&type=template&id=0ebd9199&scoped=true&"
import script from "./coach-rank.vue?vue&type=script&lang=js&"
export * from "./coach-rank.vue?vue&type=script&lang=js&"
import style0 from "./coach-rank.vue?vue&type=style&index=0&id=0ebd9199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd9199",
  null
  
)

export default component.exports